import React from "react";

import "./style.scss";

interface Props {
    autoFocus?: boolean;
    value: string;
    onChange: React.Dispatch<string>;
    placeholder: string;
    onFocus?: any;
    onBlur?: any;
    onEnter?: any;
    setSubmitted?: any;
}

export const SearchTextField = ({
    autoFocus,
    value,
    onChange,
    placeholder,
    onFocus,
    onBlur,
    onEnter,
    setSubmitted
}: Props) => {
    const ref = React.useRef(null);

    React.useEffect(() => {
        if (autoFocus && ref && ref.current) {
            // @ts-ignore
            ref.current.focus();
        }
    }, [autoFocus, ref]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode === 13) {
            onEnter();
        }
    };

    return (
        <input
            className="searchTextField"
            ref={ref}
            name="q"
            type="text"
            autoComplete="off"
            placeholder={placeholder}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={onEnter ? handleKeyDown : undefined}
            value={value}
            onChange={e => {
                setSubmitted(false);
                return onChange(e.target.value);
            }}
        />
    );
};
